import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ErrorPage from '../../components/ErrorPage';
import PageTitle from '../../components/PageTitle';

/**
 * Stable, screenshot-visible support reference for this terminal error.
 * Kept opaque to end users while letting DoS / support triage identify AWS captcha
 * rate-limit failures without digging through a HAR for 405s.
 */
export const AWS_CAPTCHA_FAILURE_LIMIT_SUPPORT_REF = 'AID-ACL-LIMIT';

export const AwsCaptchaFailureLimitErrorPage = () => {
  const { formatMessage } = useIntl();
  // Intentionally generic (matches the base error page): avoids revealing details about the WAF
  // security check to clients while still directing genuine users to support.
  const title = formatMessage({
    id: 'error.title',
    defaultMessage: 'Something went wrong.',
  });

  return (
    <>
      <PageTitle title={title} />
      <ErrorPage title={title}>
        <p>
          <FormattedMessage
            id="error.contact.support.desc"
            defaultMessage="Please contact Atlassian Support for help."
          />
        </p>
        <p>
          <small className="error-diagnostic-details">
            <code data-testid="aws-captcha-failure-limit-ref-idf-testid">
              {AWS_CAPTCHA_FAILURE_LIMIT_SUPPORT_REF}
            </code>
          </small>
        </p>
      </ErrorPage>
    </>
  );
};

export default AwsCaptchaFailureLimitErrorPage;
